export default "__VITE_ASSET__Cwox02cr__"